import React, { Component } from 'react'
import { withTranslate } from 'react-redux-multilingual'
import {
  extractFilterOptions,
  clearFilterOptionValues,
  updateFilterOptions,
  updateObject
} from '../../../../helpers/utils'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'
// import ActionBar from '../../../../components/ActionBar/ActionBar'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
// import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
// import Form from '../../../../components/PageContent/Dashboard/DashboardOverallPerformace/Form/Form'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import Modal from '../../../../components/UI/Modal/Modal'
import Form from '../../../../components/PageContent/Dashboard/DashboardOverallPerformace/Form/Form'
import { ScatterPlot } from '@nivo/scatterplot'
import _ from 'lodash'
// import Typography from '@material-ui/core/Typography'
// import Tooltip from '@material-ui/core/Tooltip'
import PieChart from './PieChart'
import TabIcon from '@material-ui/icons/Tab'
import { BoxLegendSvg } from '@nivo/legends'
import PageInfo from '../../../../components/PageInfo/PageInfo'
class DashboardOverallPerformace extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    colorGroup: [],
    filter: {},
    commonProps: {
      width: 550,
      height: 350,
      margin: { top: 10, right: 24, bottom: 80, left: 80 },
      nodeSize: 10
    },
    param: {},
    label: null,
    records: [],
    chart_scatter: [],
    scatter: [],
    select: [],
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterForm: this.props.filterForm,
      filterLevelGroup: this.props.filterLevelGroup,
      filterOrg: this.props.filterOrg,
      filterPosition: this.props.filterPosition,
      filterEmp: this.props.filterEmp,
      filterAppraisalType: this.props.filterAppraisalType,
      filterStructure: this.props.filterStructure
    },

    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structure'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('level'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: false
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        required: false
      },
      emp_id: {
        label: this.props.translate('employeeName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employeeName'),
          options: []
        },
        required: false
      }
    },
    filterOptions: {
      appraisalTypeOptions: null,
      companyFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      levelGroupFilterOptions: null,
      orgFilterOptions: null,
      positionFilterOptions: null,
      empFilterOptions: null
    },
    // Cache
    filteredCache: null
  }

  componentDidMount = () => {
    this.props.fetchAppraisalTypeOptions()
    this.props.fetchCompanyOptions()

    if (this.props.filtered) {
      const { appraisalType, company } = this.props.filtered

      this.props.filterAppraisalRecords(this.props.filtered)

      this.setState({
        appraisalType,
        company
      })
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }
    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }
    if (
      props.filterOptions.appraisalTypeOptions !== updatedState.filterOptions.appraisalTypeOptions
    ) {
      const appraisalTypeFilter = updatedState.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.appraisalTypeOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' },
        'Select Appraisal Type',
        false,
        updatedState.filterControls.appraisal_type_id.value,
        'appraisal_type_code'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeOptions: props.filterOptions.appraisalTypeOptions
        }
      }
    }
    if (
      props.filterOptions.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions
    ) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.company_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.form_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (
      props.filterOptions.structureFilterOptions !==
      updatedState.filterOptions.structureFilterOptions
    ) {
      const structureFilter = updatedState.filterControls.structure_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.structure_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      const { structureFilterOptions } = props.filterOptions
      let defaultValue = ''
      if (structureFilterOptions && structureFilterOptions.length > 0) {
        const target = structureFilterOptions.find(s => s.structure_id === 1)
        if (target) {
          defaultValue = {
            key: target.structure_id,
            value: target.structure_id,
            label: target.structure_name
          }
        }
      }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          structure_id: updateObject(updatedFilterItem, { value: defaultValue })
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.filterOptions.structureFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !==
      updatedState.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.level_group_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.org_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (
      props.filterOptions.positionFilterOptions !== updatedState.filterOptions.positionFilterOptions
    ) {
      const positionFilter = updatedState.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.position_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    if (props.filterOptions.empFilterOptions !== updatedState.filterOptions.empFilterOptions) {
      const employeeFilter = updatedState.filterControls.emp_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.empFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.emp_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { emp_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.filterOptions.empFilterOptions
        }
      }
    }
    if (!_.isEqual(props.records, updatedState.records)) {
      let chart_scatter = []
      if (!_.isEmpty(props.records)) {
        chart_scatter = props.records.chart_scatter.map(item => {
          let node = item.data.map((n, index) => {
            let color = '#C0C0C0'
            if (item.data[index]) {
              let percent_achievement = item.data[index].z
              let thresholds = props.records.all_kpi.thresholds.threshold.find(
                item =>
                  percent_achievement <= +item.end_value && percent_achievement >= +item.start_value
              )

              if (thresholds) {
                color = thresholds.color_code
              }
            }

            return {
              ...n,
              color: color
            }
          })
          return {
            ...item,
            data: node
          }
        })
      }

      updatedState = {
        ...updatedState,
        records: props.records,
        scatter: chart_scatter,
        select: [],
        chart_scatter: chart_scatter
      }
    }
    return updatedState
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = {
      ...this.state.filter
    }
    let parameters = {}
    let checkStructure = true
    Object.entries(filter).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        if (key === 'structure_id') {
          checkStructure = false
        }
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })

    if (checkStructure) {
      parameters = {
        ...parameters,
        structure_id: 1
      }
    }

    // parameters = {
    //   company_id: 1,
    //   appraisal_type_id: 10,
    //   form_id: 1,
    //   structure_id: 1,
    //   level_group_id: 1,
    //   org_id: 99,
    //   position_id: 257,
    //   emp_id: 269
    // }

    let param = {
      ...parameters,
      appraisal_type_id: filter.appraisal_type_id
    }

    this.setState({
      param: param
    })

    this.props.fetchDashboardOverallPerformace(param)
    this.closeFilterModal()
  }

  componentWillUnmount() {
    this.clearFilter()
  }

  // Cleaner Methods
  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter,
      filteredCache: null
    })
  }

  selectPerspective = event => {
    let label = ''
    if (event === 'center') {
      this.props.fetchDashboardOverallPerformace(extractFilterOptions(this.state.filterControls))
      label = 'ทั้งหมด'
    } else {
      this.props.fetchDashboardOverallPerformace({
        ...extractFilterOptions(this.state.filterControls),
        perspective_id: event.id
      })
      label = event.label
    }

    this.setState({
      label: label
    })
  }
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    const filterOptions = {
      appraisal_type_id: updatedFilterControls.appraisal_type_id.value?.value,
      company_id: updatedFilterControls.company_id.value?.value,
      structure_id: updatedFilterControls.structure_id.value?.value,
      level_group_id: updatedFilterControls.level_group_id.value?.value,
      org_id: updatedFilterControls.org_id.value?.value,
      position_id: updatedFilterControls.position_id.value?.value
    }

    if (itemKey === 'appraisal_type_id' && event) {
      const { label } = event
      const { filterControls } = this.state
      if (label.includes('Individual')) {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = false
        filterControls.position_id.required = false
        filterControls.emp_id.required = true

        filterControls.position_id.configs.disabled = false
        filterControls.emp_id.configs.disabled = false
      } else {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = true
        filterControls.position_id.required = false
        filterControls.emp_id.required = false

        filterControls.position_id.configs.disabled = true
        filterControls.emp_id.configs.disabled = true
      }

      updatedFilterControls = {
        ...updatedFilterControls
      }
    }
    if (['company_id', 'appraisal_type_id'].includes(itemKey) && filterOptions.appraisal_type_id) {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'emp_id') {
      if (updatedFilterControls.org_id.value === null) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_id === event.value
        )

        let org_id = findEmp.empdetails[0].org_id

        updatedFilterControls.org_id.value = updatedFilterControls.org_id.configs.options.find(
          item => item.value === org_id
        )
      }

      if (updatedFilterControls.position_id.value === null) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_id === event.value
        )
        let position_id = findEmp.empdetails[0].position_id

        updatedFilterControls.position_id.value = updatedFilterControls.position_id.configs.options.find(
          item => item.value === +position_id
        )
      }
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    }
  }

  filterRecords = () => {
    let filters = extractFilterOptions(this.state.filterControls)
    const appraisalType = this.state.filterControls.appraisal_type_id.value
    const company = this.state.filterControls.company_id.value

    this.setState({
      appraisalType: appraisalType,
      company: company
    })

    this.props.fetchDashboardOverallPerformace({ ...filters, appraisalType, company })
    this.closeFilterModal(true)
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }
  closeModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  chartTooltip = node => {
    let select = []
    let selectAxis = null

    this.props.records.chart_scatter.map(item => {
      if (item.id === node.data.serieId) {
        select = item.data.filter(val => {
          return val.x === node.data.x && val.y === node.data.y && val.z === node.data.z
        })

        selectAxis = select.map(ax => {
          return item.mouse_over_data[ax.id]
        })
      }
      return item
    })

    // return null
    return (
      <div
        style={{
          color: 'white',
          background: 'rgba(0, 0, 0, 0.6)',
          padding: '12px 16px',
          borderRadius: '5px',
          maxWidth: '180px',
          alignContent: 'start',
          zIndex: 1024999999,
          minWidth: '250px'
        }}>
        {/* <strong>
          {node.id} ({node.serieId})
        </strong>
        <br />
        {`x: ${node.data.formattedX}`}
        <br />
        {`y: ${node.data.formattedY}`} */}
        {selectAxis.map(item => (
          <Aux>
            <div style={{ paddingBottom: '10px', textAlign: 'start' }}>{item.item_name}</div>
            <div style={{ textAlign: 'start' }}>ทำได้: {item.percent_achievement}</div>
            <div style={{ textAlign: 'start' }}>
              {this.props.translate('urgencyLevel')}: {item.target_value}
            </div>
            <div style={{ textAlign: 'start' }}>
              {this.props.translate('impactLevel')}: {item.priority}
            </div>
            <div style={{ textAlign: 'start' }}>as_of: {item.as_of}</div>
            <hr></hr>
          </Aux>
        ))}
      </div>
    )
  }

  getaxis = (value, label) => {
    let axis = []
    this.props.records.chart_scatter_axis.map(item => {
      let lastChar = item.value_list_code[item.value_list_code.length - 1]
      if (lastChar === label) {
        axis.push(item)
      }
      return item
    })
    let axisText = ''
    axis.map(ax => {
      if (value === parseInt(ax.value_list_name)) {
        axisText = ax.value_list_code
      }
      return ax
    })

    return this.props.translate(axisText)
  }

  getMaker = () => {
    let axis = []
    this.props.records.chart_scatter_axis.map(item => {
      let lastChar = item.value_list_code[item.value_list_code.length - 1]
      if (lastChar === 'X') {
        axis.push({
          axis: 'x',
          value: item.value_list_name,
          legend: this.props.translate(item.value_list_code),
          // legendOrientation: 'vertical',
          // legendOffsetX: 0,
          // legendOffsetY: 0,
          legendPosition: 'bottom',
          // LegendPosition: 'start',
          // ['text-anchor']: 'start',
          // textAnchor: 'start',
          // anchor: 'start',
          textStyle: { fontSize: 10 },
          lineStyle: { stroke: 'rgb(119, 119, 119)', strokeWidth: 1, strokeDasharray: '8,8' }
        })
      } else if (lastChar === 'Y') {
        axis.push({
          axis: 'y',
          value: item.value_list_name,
          legend: this.props.translate(item.value_list_code),
          legendPosition: 'left',
          textStyle: { fontSize: 10 },
          lineStyle: { stroke: 'rgb(119, 119, 119)', strokeWidth: 1, strokeDasharray: '8,8' }
        })
      }
      return item
    })
    return axis
  }

  CustomNode = ({
    node,
    x,
    y,
    size,
    blendMode,
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    onClick
  }) => {
    // let color = '#C0C0C0'
    // let thresholds = this.props.records.all_kpi.thresholds.threshold.find(
    //   item => node.data.z <= +item.end_value && node.data.z >= +item.start_value
    // )

    // if (thresholds) {
    //   color = thresholds.color_code
    // }

    return (
      // <Tooltip title='Add' placement='top'>
      <svg>
        <defs>
          <filter id='spotlight'>
            <feGaussianBlur in='SourceAlpha' stdDeviation={4 * size * -0.5} result='blur' />
            <feOffset in='blur' dx='4' dy='4' result='offsetBlur' />
            <feSpecularLighting
              in='blur'
              surfaceScale={5 * size * 0.5}
              specularConstant='.75'
              specularExponent={20}
              lighting-color='#bbbbbb'
              result='specOut'>
              <fePointLight x={size * -0.5} y={size * -0.5} z={size * -0.5} />
            </feSpecularLighting>
            <feComposite in='specOut' in2='SourceAlpha' operator='in' result='specOut' />
            <feComposite
              in='SourceGraphic'
              in2='specOut'
              operator='arithmetic'
              k1='0'
              k2='1'
              k3='1'
              k4='0'
              result='litPaint'
            />
            <feMerge>
              <feMergeNode in='offsetBlur' />
              <feMergeNode in='litPaint' />
            </feMerge>
          </filter>
        </defs>
        <g transform={`translate(${x},${y})`}>
          <rect
            x={size * -0.5}
            y={size * -0.5}
            rx={size}
            ry={size}
            width={size}
            height={size}
            fill={node.data.color}
            fillOpacity={0.65}
            style={{
              // mixBlendMode: blendMode,
              // zIndex: -1,
              position: 'absolute',
              top: true
              // stroke: 'black',
              // strokeWidth: 0.5
            }}
            onMouseEnter={onMouseEnter}
            onMouseMove={onMouseMove}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
          />
        </g>
      </svg>
      // </Tooltip>
    )
  }
  formatData = data => {
    let format = data.map(item => {
      return {
        ...item,
        id: this.props.translate(item.id)
      }
    })
    return format
  }
  nodeSize = data => {
    let min = 0
    let max = 10
    data.map(item => {
      item.data.map(v => {
        if (v.z < min) {
          min = v.z
        }
        if (v.z > max) {
          max = v.z
        }
        return v
      })
      return item
    })
    return [min, max]
  }
  BarLegend = ({ height, legends, width }) => {
    let colorGroup = []
    this.props.records.chart_scatter.map(item => {
      item.data.map(data => {
        let color = this.props.records.all_kpi.thresholds.threshold.find(
          threshold => +data.z <= +threshold.end_value && +data.z >= +threshold.start_value
        )
        if (color) {
          if (!colorGroup.find(check => check.color_code === color.color_code)) {
            colorGroup.push(color)
          }
        } else {
          if (!colorGroup.find(check => check.color_code === '#C0C0C0')) {
            colorGroup.push({
              color_code: '#C0C0C0'
            })
          }
        }
        return data
      })
      // if (item.id === node.data.serieId) {
      //   let percent_achievement = item.mouse_over_data[node.index].percent_achievement
      //   let thresholds = this.props.records.all_kpi.thresholds.threshold.find(
      //     item => percent_achievement <= +item.end_value
      //   )
      //   color = thresholds.color_code
      //   if (!colorGroup.find(item => item.color_code === color)) {
      //     colorGroup.push(thresholds)
      //   }
      // }
      return item
    })

    if (colorGroup.length > 0) {
      colorGroup = colorGroup.map(item => {
        if (item.color_code === '#C0C0C0') {
          return {
            color: item.color_code,
            colorData: item.color_code,
            id: 'out of range',
            label: 'out of range'
          }
        } else {
          let label = `${item.start_value} - ${item.end_value}`
          return {
            color: item.color_code,
            colorData: item.color_code,
            id: label,
            label: label
          }
        }
      })
    } else {
      colorGroup = [
        {
          color: 'white',
          colorData: 'white',
          id: null,
          label: null
        }
      ]
    }

    let checkSelect = this.state.select

    checkSelect.map(item => {
      colorGroup = colorGroup.map(g => {
        if (item.color === g.color) {
          return {
            ...g,
            color: 'gray'
          }
        } else {
          return g
        }
      })
      return item
    })

    colorGroup = colorGroup.map(item => {
      return {
        ...item,
        start: item.id.split('-')[0]
      }
    })
    colorGroup = colorGroup.sort((a, b) => {
      if (parseFloat(a.start) && parseFloat(b.start)) {
        return parseFloat(a.start) - parseFloat(b.start)
      } else if (parseFloat(a.start)) {
        return -1
      } else {
        return 1
      }
    })
    return (
      <React.Fragment>
        {legends.map(legend => (
          <BoxLegendSvg
            key={JSON.stringify(legend.data.map(({ id }) => id))}
            {...legend}
            data={colorGroup}
            containerHeight={height}
            containerWidth={width}
            onClick={e => this.selectNode(e)}
          />
        ))}
      </React.Fragment>
    )
  }
  selectNode = e => {
    let select = this.state.select
    let check = select.find(se => se.colorData === e.colorData)

    if (check) {
      select = select.filter(se => !(se.colorData === e.colorData))
    } else {
      select.push(e)
    }
    let allNode = [...this.state.scatter]
    select.map(ee => {
      allNode = allNode.map(item => {
        let selectNode = item.data.filter(n => n.color !== ee.colorData)
        return { ...item, data: selectNode }
      })
      return ee
    })
    this.setState({
      chart_scatter: allNode,
      select: select
    })
  }
  checkMin = axis => {
    let minX = 0
    let minY = 0
    let maxX = 0
    let maxY = 0
    this.props.records.chart_scatter.map(item => {
      item.data.map(data => {
        if (+data.x < minX) {
          minX = +data.x
        }
        if (+data.x > maxX) {
          maxX = +data.x
        }
        if (+data.y < minY) {
          minY = +data.x
        }
        if (+data.y > maxY) {
          maxY = +data.x
        }
        return data
      })
      return item
    })
    if (axis === 'minX') {
      return minX < 0 ? minX - 10 : 0
    } else if (axis === 'maxX') {
      return maxX > 100 ? maxY + 10 : 100
    } else if (axis === 'minY') {
      return minY < 0 ? minX - 10 : 0
    } else if (axis === 'maxY') {
      return maxY > 100 ? maxY + 10 : 100
    } else {
      return 0
    }
  }
  render() {
    const keysDealer = ['Week 1', 'Week 2', 'Week 3', 'Week 4', '%Achievement']
    const colorsDealer = ['#89A3D3', '#4BEBDD', '#28E799', '#3F77E0', 'rgba(230, 245, 0, 1)']
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
    let chart = <PleaseFilter />
    let pie = null
    if (!_.isEmpty(this.props.records)) {
      if (this.state.label === null) {
        this.setState({
          label: 'ทั้งหมด'
        })
      }
      pie = (
        <PieChart
          data={this.props.records.chart_pie[0].items}
          // center={this.props.records.chart_pie[0].items}
          center={{ ...this.props.records.chart_pie[0].center, noTooltip: true }}
          selectPerspective={event => this.selectPerspective(event)}
        />
      )
      // var lastChar = myString[myString.length - 1]
      let axisX = []
      let axisY = []
      this.props.records.chart_scatter_axis.map(item => {
        let lastChar = item.value_list_code[item.value_list_code.length - 1]
        if (lastChar === 'X') {
          axisX.push(item)
        } else if (lastChar === 'Y') {
          axisY.push(item)
        }
        return item
      })

      chart = (
        <div>
          <ScatterPlot
            {...this.state.commonProps}
            tooltip={({ node }) => this.chartTooltip(node)}
            data={this.formatData(this.state.chart_scatter)}
            nodeSize={{
              key: 'z',
              values: this.nodeSize(this.state.chart_scatter),
              sizes: [10, 100]
            }}
            yScale={{
              type: 'linear',
              min: this.checkMin('minY', 'yScalemin'),
              max: this.checkMin('maxY', 'yScalemax')
            }}
            xScale={{
              type: 'linear',
              min: this.checkMin('minX', 'xScalemin'),
              max: this.checkMin('maxX', 'yScalemax')
            }}
            renderNode={this.CustomNode}
            markers={this.getMaker()}
            axisLeft={{
              format: value => null,
              legend: this.props.translate('impactLevel'),
              legendPosition: 'middle',
              legendOffset: -55
            }}
            axisBottom={{
              format: value => null,
              legend: this.props.translate('urgencyLevel'),
              legendPosition: 'middle',
              legendOffset: 46
            }}
            theme={{
              labels: {
                text: {
                  fontSize: '17px'
                }
              },
              tooltip: {
                container: {
                  zIndex: 1024
                }
              }
            }}
            enableGridX={false}
            enableGridY={false}
            legends={[
              {
                data: keysDealer.map((id, index) => ({
                  color: colorsDealer[index],
                  id,
                  label: id
                })),
                // anchor: 'center',
                anchor: 'bottom-left',
                direction: 'row',
                justify: false,
                translateX: -50,
                translateY: -20,
                itemWidth: 100,
                itemHeight: 12,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 1
                    }
                  }
                ]
              }
            ]}
            layers={['grid', 'axes', 'nodes', 'markers', 'mesh', this.BarLegend]}
            // layers={['grid', 'axes', 'bars', 'markers', this.BarLegend]}
          />
        </div>
      )
      formLoading = (
        <Grid container spacing={1} style={{ paddingBottom: 0, marginBottom: 0 }}>
          <Grid item xs={12} md={6} style={{ paddingBottom: 0, marginBottom: 0 }}>
            <h2 style={{ fontSize: '16px' }}> {this.props.translate('perspectivePerformance')}</h2>
            {/* <Card>{pie}</Card> */}
            {pie}
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingBottom: 0, marginBottom: 0, paddingRight: 20, overflowX: 'auto' }}>
            <Grid container direction='row' justify='space-between' alignItems='center' xs={12}>
              <Grid item xs={12} md={9}>
                {/* <Typography gutterBottom variant='subtitle1'>
                  {`ประสิทธิภาพตัวชี้วัด ${this.state.label} `}
                </Typography> */}
                <h2 style={{ fontSize: '16px' }}>{`${this.props.translate('kpiPerformance')} ${
                  this.state.label
                } `}</h2>
              </Grid>
              <Grid item xs={12} md={3}>
                <Button
                  startIcon={<TabIcon />}
                  // color={'primary'}
                  clicked={() => this.openModal()}>
                  {this.props.translate('allKpi')}
                </Button>
              </Grid>
            </Grid>
            {chart}
            {/* <Card style={{ overflow: 'visible' }}>{chart}</Card> */}
          </Grid>
        </Grid>
      )
    }
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          filterControls={this.state.filterControls}
          filterSaved={this.filterRecords}
          filterChanged={this.filterChangedHandler}
          cancelled={this.closeFilterModal}
          loadingQueue={this.props.filterLoading}
        />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={'ตัวชี้วัดทั้งหมด'}
          backdropClicked={this.closeModal}
          buttonClose={true}
          size={'xl'}>
          {/* <div className={classes.ModalBody}> */}
          {this.props.records && this.props.records.all_kpi && (
            <Form
              data={this.props.records.all_kpi}
              center={{ ...this.props.records.chart_pie[0].center }}
            />
          )}
          {/* </div> */}
        </Modal>
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs={12} sm md>
                  <PageInfo pageTranslateKey={'overallPerformance'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }
            subheader={
              this.props.records.length !== 0 ? this.props.records.chart_pie[0].center.label : null
            }
            subheaderTypographyProps={{ color: 'textPrimary', variant: 'h6' }}>
            {/* Dashboard Overall Performace
            <FilterBar buttonClicked={this.openFilterModal} 
            /> */}
          </CardHeader>

          {/* <CardBody style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}> */}
          {formLoading}
          {/* </CardBody> */}
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.dashboardOverallPerformance.loading,
    filterLoading: state.dashboardOverallPerformance.loadingStates,
    success: state.dashboardOverallPerformance.success,
    companyOptions: state.dashboardOverallPerformance.company,
    filterCompany: state.dashboardOverallPerformance.filterCompany,
    filterForm: state.dashboardOverallPerformance.form,
    filterLevelGroup: state.dashboardOverallPerformance.levelGroup,
    filterOrg: state.dashboardOverallPerformance.org,
    filterPosition: state.dashboardOverallPerformance.position,
    filterEmp: state.dashboardOverallPerformance.emp,
    filterAppraisalType: state.dashboardOverallPerformance.appraisalType,
    filterStructure: state.dashboardOverallPerformance.structure,
    records: state.dashboardOverallPerformance.records,
    filterOptions: {
      appraisalTypeOptions: state.dashboardOverallPerformance.appraisalType,
      companyFilterOptions: state.dashboardOverallPerformance.company,
      formFilterOptions: state.dashboardOverallPerformance.form,
      structureFilterOptions: state.dashboardOverallPerformance.structure,
      levelGroupFilterOptions: state.dashboardOverallPerformance.levelGroup,
      orgFilterOptions: state.dashboardOverallPerformance.org,
      positionFilterOptions: state.dashboardOverallPerformance.position,
      empFilterOptions: state.dashboardOverallPerformance.emp
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
      dispatch(actions.fetchCompanyOptions())
    },
    fetchAppraisalTypeOptions: () => dispatch(actions.fetchAppraisalTypeOptionsForAppraisal()),
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptions(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptions(filter)),
    fetchOrganizationOptions: filter =>
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filter)),
    fetchPositionOptions: filter => dispatch(actions.fetchPositionOptionsForAppraisal(filter)),
    fetchEmployeeOptions: filter => dispatch(actions.fetchEmployeeOptions(filter)),
    fetchLevelGroupOptions: filter => dispatch(actions.fetchLevelGroupOptions(filter)),
    fetchStructureOptions: filter =>
      dispatch(
        actions.fetchStructureOptionsForAppraisal({
          ...filter,
          structure_type_code: ['STT01', 'STT04']
        })
      ),
    fetchDashboardOverallPerformace: filter =>
      dispatch(actions.fetchDashboardOverallPerformace(filter)),
    clearReportKpi: () => dispatch(actions.clearReportKpi())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslate(DashboardOverallPerformace))
